const TABLES = {
  articles: 33215,
  reviewers: 33216,
  tags: 33217,
  articles_to_tags: 33218,
  translations: 33219,
};

const CATEGORIES = {
  person: 17946,
  organisation: 17947,
  city_area: 17948,
  country: 17949,
  topic: 17950,
};

const STATUS = {
  approved: 17942,
  pending: 17943,
  rejected: 17944,
  published: 17945,
};

const COLUMNS = {
  STATUS: 'field_177157',
  CATEGORY: 'field_177168',
  EMAIL: 'field_177159',
  PIN: 'field_177161',
  TAGS: 'field_184121',
  TAG_TITLE: 'field_177167',
};

const ARTICLE_FIELDS = {
  YEAR: 'field_177138',
  MONTH: 'field_177139',
  DAY: 'field_177140',
};

const MAP = {
  GENERAL: 'https://map.workingclasshistory.com/',
  SPECIFIC: `https://map.workingclasshistory.com/?event=:id#%26map=9/:lat/:long`,
};

export { TABLES, CATEGORIES, STATUS, COLUMNS, MAP, ARTICLE_FIELDS };
